import Vuex from 'vuex';
import Vue from 'vue';
Vue.use(Vuex);
import { AxiosErrorHandler, isAxiosError } from './util/AxiosErrorHandler';
import BASEAPI from "@/util/BASEAPI";
import { LoginStatus } from './generated/api';

interface RootState {
    user: LoginStatus | null;
    error: string;}

export default new Vuex.Store<RootState>({
    state: {
        user: null,
        error: "",
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        getUserAPI: async (state) => {
            let res = await BASEAPI.LoginController.loginStatusUsingGET().catch(AxiosErrorHandler);
            if (isAxiosError(res)) {
                if (res.status == 999) {
                    state.state.error = "通信エラーが発生しました。通信環境の良いところで再度アクセスしてください。";
                } else {
                    state.state.error = "サーバーエラーが発生しました。しばらく時間をおいてから再度アクセスしてください。";
                }
            } else {
                if (res.data.userId) {
                    // ログイン中
                    state.state.user = res.data;
                } else {
                    // ログアウト中
                    state.state.user = null;
                }
            }
        },
    },
});
